var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { class: _vm.$style.header }, [
    _c(
      "a",
      {
        class: _vm.$style.headerLink,
        attrs: { href: "https://jumpcloud.com" },
      },
      [_c("LogoIcon", { class: _vm.$style.logoIcon, attrs: { fixed: false } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }